import React, { useState, useEffect, useRef, useLayoutEffect } from "react";
import "./GameBoard.css";
import HowToPlay from "./HowToPlay";
import redCar from "../assets/redcar.png";
import blueCar from "../assets/bluecar.png";
import { userGameRewards } from "../../../../apis/user";

const handleApiResponse = async (points) => {
  if (points <= 0) {
    return;
  }

  try {
    const apiData = {
      gamePoints: points,
      gameType: "carrace",
    };
    const res = await userGameRewards(apiData);

    if (res) {
      // Score submitted successfully
    }
  } catch (error) {
    // API call failed
  }
};

const Twocar = () => {
  const [redLane, setRedLane] = useState(0);
  const [lanePositions, setLanePositions] = useState([]);

  const gameBoardRef = useRef(null);

  const [blueLane, setBlueLane] = useState(2);
  const [objects, setObjects] = useState([]);
  const [score, setScore] = useState(0);
  const [highScore, setHighScore] = useState(
    () => localStorage.getItem("highScore") || 0
  );
  const [gameOver, setGameOver] = useState(false);
  const [gameStarted, setGameStarted] = useState(false);
  const [spawnSpeed, setSpawnSpeed] = useState(800);
  const [fallSpeed, setFallSpeed] = useState(3);
  const [showHowToPlay, setShowHowToPlay] = useState(true); // Show instructions initially
  const [failedObject, setFailedObject] = useState(null);
  const redCarRef = useRef(null);
  const blueCarRef = useRef(null);
  const getReducedHitbox = (rect, shrink = 8) => {
    const offset = shrink / 2;
    return {
      top: rect.top + offset,
      bottom: rect.bottom - offset,
      left: rect.left + offset,
      right: rect.right - offset,
    };
  };

  // In GameBoard.jsx, replace your old useLayoutEffect
  useLayoutEffect(() => {
    const calculatePositions = () => {
      if (gameBoardRef.current) {
        const boardWidth = gameBoardRef.current.clientWidth;
        // --- THIS IS THE CHANGE ---
        // These are the center-points of the 5 lanes the cars can be in
        setLanePositions([
          boardWidth * 0.125, // Lane 1
          boardWidth * 0.375, // Lane 2
          boardWidth * 0.625, // Lane 3
          boardWidth * 0.875, // Lane 4
        ]);
      }
    };
    calculatePositions();
    window.addEventListener("resize", calculatePositions);
    return () => window.removeEventListener("resize", calculatePositions);
  }, []);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!gameStarted || gameOver) return;
      if (e.key === "a" || e.key === "A") {
        setRedLane((prev) => (prev === 0 ? 1 : 0));
      } else if (
        e.key === "ArrowLeft" ||
        e.key === "d" ||
        e.key === "D" ||
        e.key === "ArrowRight"
      ) {
        setBlueLane((prev) => (prev === 2 ? 3 : 2));
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [gameOver, gameStarted]);

  useEffect(() => {
    const handleTouch = (e) => {
      if (!gameStarted || gameOver || !gameBoardRef.current) return;
      const x = e.touches[0].clientX;
      const gameBoardRect = gameBoardRef.current.getBoundingClientRect();
      const touchXInBoard = x - gameBoardRect.left;

      if (touchXInBoard < gameBoardRect.width / 2) {
        setRedLane((prev) => (prev === 0 ? 1 : 0));
      } else {
        setBlueLane((prev) => (prev === 2 ? 3 : 2));
      }
    };
    window.addEventListener("touchstart", handleTouch);
    return () => window.removeEventListener("touchstart", handleTouch);
  }, [gameOver, gameStarted]);

  /* --- ADD THIS NEW, CORRECTED GAME LOOP --- */
  useEffect(() => {
    if (!gameStarted || gameOver || lanePositions.length === 0) return;

    let animationId;
    const lastTimeRef = { current: performance.now() };

    // These constants MUST match your CSS for accurate calculations
    const CAR_BOTTOM_PERCENT = 5;
    const OBJECT_WIDTH_VW = 6;
    const CAR_WIDTH_VW = 10; // This should match the .car width in your CSS

    const update = (time) => {
      const delta = Math.min((time - lastTimeRef.current) / 1000, 0.05);
      lastTimeRef.current = time;

      const boardElement = gameBoardRef.current;
      if (!boardElement) return;
      const boardHeight = boardElement.clientHeight;
      const boardWidth = boardElement.clientWidth;

      // --- THE FIX: Calculate sizes dynamically every frame ---
      const vw = boardWidth / 100;
      const objectSizePx = OBJECT_WIDTH_VW * vw;
      const carWidthPx = CAR_WIDTH_VW * vw;
      // Assuming a top-down car sprite is taller than it is wide
      const carHeightPx = carWidthPx * 1.5;

      const carHitboxTop =
        boardHeight * (1 - CAR_BOTTOM_PERCENT / 100) - carHeightPx;
      const carHitboxBottom = boardHeight * (1 - CAR_BOTTOM_PERCENT / 100);

      setObjects((prevObjects) => {
        const newObjects = [];
        let hasCollected = false;
        let failed = null;

        for (const obj of prevObjects) {
          const isRed = obj.color === "red";
          // This logic now works with the 5-lane system
          const activeCarLaneIndex = isRed ? redLane : blueLane;
          const carLaneCenter = lanePositions[activeCarLaneIndex];

          const objectLaneCenter = lanePositions[obj.lane];
          const objTop = obj.top;
          // --- THE FIX: Use the dynamic size for the hitbox ---
          const objBottom = objTop + objectSizePx;
          const objLeft = objectLaneCenter - objectSizePx / 2;
          const objRight = objectLaneCenter + objectSizePx / 2;

          const carHitboxLeft = carLaneCenter - carWidthPx / 2;
          const carHitboxRight = carLaneCenter + carWidthPx / 2;

          const verticalOverlap =
            objBottom >= carHitboxTop && objTop <= carHitboxBottom;
          const horizontalOverlap =
            objRight >= carHitboxLeft && objLeft <= carHitboxRight;

          if (
            obj.lane === activeCarLaneIndex &&
            verticalOverlap &&
            horizontalOverlap
          ) {
            if (obj.shape === "square") {
              failed = obj;
            } else {
              hasCollected = true;
            }
            continue;
          }

          if (objTop > boardHeight) {
            if (obj.shape === "circle") {
              failed = obj;
            }
            continue;
          }

          newObjects.push({ ...obj, top: objTop + fallSpeed * delta * 60 });
        }

        if (failed) {
          setFailedObject(failed);
          setGameOver(true);
          return prevObjects;
        }

        if (hasCollected) {
          setScore((prev) => prev + 10);
        }
        return newObjects;
      });

      animationId = requestAnimationFrame(update);
    };

    animationId = requestAnimationFrame(update);
    return () => cancelAnimationFrame(animationId);
  }, [gameStarted, gameOver, redLane, blueLane, fallSpeed, lanePositions]);

  /* --- ADD THIS NEW, FULLY CORRECTED SPAWNING LOGIC --- */
  useEffect(() => {
    if (!gameStarted || gameOver) return;

    const interval = setInterval(() => {
      setObjects((prev) => {
        const color = Math.random() > 0.5 ? "red" : "blue";
        let shape = Math.random() > 0.7 ? "square" : "circle"; // Squares are less common
        const isRed = color === "red";

        // This is the logic for the 4-lane system
        const lane = isRed
          ? Math.floor(Math.random() * 2) // Spawns in lane 0 or 1
          : 2 + Math.floor(Math.random() * 2); // Spawns in lane 2 or 3

        // --- NEW ROBUST FAIRNESS LOGIC ---
        if (shape === "square") {
          // Determine the other lane for the current car
          let otherLane;
          if (isRed) {
            otherLane = lane === 0 ? 1 : 0; // If new lane is 0, other is 1, and vice-versa
          } else {
            // It's blue
            otherLane = lane === 2 ? 3 : 2; // If new lane is 2, other is 3, and vice-versa
          }

          // Check if there is ALREADY a square in that other lane near the top
          const isWallPresent = prev.some(
            (obj) =>
              obj.lane === otherLane && obj.shape === "square" && obj.top < 150
          );

          if (isWallPresent) {
            // An impossible wall would be created. Force this to be a circle.
            shape = "circle";
          }
        }
        // --- END OF NEW LOGIC ---

        // Enforce a larger vertical gap in the same lane
        const tooCloseVertically = prev.some(
          (obj) => obj.lane === lane && obj.top < 200
        );
        if (tooCloseVertically) {
          return prev; // Skip spawning this time
        }

        const newObj = { id: Date.now(), color, shape, lane, top: -50 };
        return [...prev, newObj];
      });
    }, spawnSpeed);

    return () => clearInterval(interval);
  }, [spawnSpeed, gameOver, gameStarted]);

  useEffect(() => {
    if (!gameStarted || gameOver) return;
    const interval = setInterval(() => {
      setFallSpeed((prev) => Math.min(prev + 0.2, 14));
    }, 3000);
    return () => clearInterval(interval);
  }, [gameStarted, gameOver]);

  useEffect(() => {
    if (score < 10) setSpawnSpeed(800);
    else if (score < 20) setSpawnSpeed(650);
    else if (score < 30) setSpawnSpeed(500);
    else if (score < 50) setSpawnSpeed(400);
    else setSpawnSpeed(300);
  }, [score]);

  useEffect(() => {
    if (gameOver) {
      if (score > highScore) {
        setHighScore(score);
        localStorage.setItem("highScore", score);
      }
      // Submit score to API
      handleApiResponse(score);
    }
  }, [gameOver, score, highScore]);

  const startGame = () => {
    setGameStarted(true);
    setGameOver(false);
    setScore(0);
    setObjects([]);
    setRedLane(0);
    setBlueLane(2);
    setSpawnSpeed(800);
    setFallSpeed(3);
    setFailedObject(null);
    setShowHowToPlay(false);
  };

  return (
    <div
      ref={gameBoardRef}
      className="game-boardcar"
      onClick={() => {
        // Start game only if not started AND instructions hidden
        if (!gameStarted && !showHowToPlay) {
          startGame();
        }
      }}
    >
      {/* Show instructions whenever showHowToPlay is true */}
      {showHowToPlay && <HowToPlay onClose={() => setShowHowToPlay(false)} />}

      {/* Show "Tap to Start" only if game not started and no instructions and no game over */}
      {!gameStarted && !showHowToPlay && !gameOver && (
        <div className="tap-to-start">Tap to Start</div>
      )}

      {/* Show Game Over & Restart button only if gameOver & no instructions */}
      {/* In your GameBoard.jsx return statement */}

      {gameOver && !showHowToPlay && (
        <div className="game-over-modal">
          <button
            className="modal-close-button"
            onClick={startGame}
            aria-label="Close"
          >
            &times;
          </button>

          <h2>GAME OVER!</h2>

          <div className="final-score-container">
            <p className="final-score-label">FINAL SCORE</p>
            <div className="score-display">
              {/* --- USE THE IMPORTED IMAGE HERE --- */}
              <img
                src="https://d1ccopf5cw1hft.cloudfront.net/s3data/coinlogo.png"
                alt="coin"
              />
              <span>{score}</span>
            </div>
          </div>
          {/* --- ADD THIS LINE HERE --- */}
          <div className="high-score">High Score: {highScore}</div>

          <button className="restart-button" onClick={startGame}>
            PLAY AGAIN
          </button>
        </div>
      )}

      <div className="score">Score: {score}</div>

      {/* CRITICAL FIX: This checks if lanePositions has been calculated.
        It prevents the error and allows the cars to render. 
      */}
      {lanePositions?.length > 0 && (
        <>
          <div className="road">
            <div className="lane" style={{ left: "25%" }} />
            <div className="lane" style={{ left: "50%" }} />
            <div className="lane" style={{ left: "75%" }} />
          </div>
          <img
            src={redCar}
            alt="Red Car"
            className="car red"
            style={{ left: `${lanePositions[redLane]}px` }}
            ref={redCarRef}
          />
          <img
            src={blueCar}
            alt="Blue Car"
            className="car blue"
            style={{ left: `${lanePositions[blueLane]}px` }}
            ref={blueCarRef}
          />

          {objects.map((obj, index) => {
            const isFailed = gameOver && failedObject && obj === failedObject;
            return (
              <div
                key={index}
                className={`object ${obj.color} ${
                  obj.shape === "square" ? "square" : ""
                } ${isFailed ? "failed-object" : ""}`}
                style={{
                  left: `${lanePositions[obj.lane]}px`,
                  top: `${obj.top}px`,
                }}
              />
            );
          })}
        </>
      )}
    </div>
  );
};
export default Twocar;
